import React from 'react';
import styled from 'styled-components';
import { zLayers, media } from '../../styles/theme';

/**
 * 共享弹窗基座 —— 统一所有 Portal 弹窗的：
 * - 遮罩层级（z-index 取自 theme.zLayers，消除 1000/1001/2000 混用）
 * - 尺寸/圆角/阴影
 * - 手机上近全屏（100dvh、去圆角），头部固定 + 内容滚动 + 底部按钮可达
 * - 禁用「点击背景遮罩关闭」（项目规则）：遮罩本身不绑定关闭事件
 *
 * 用法一（推荐迁移现有弹窗，零 JSX 改动）：把各弹窗里本地的
 *   const ModalOverlay = styled.div`...`  /  const Modal = styled.div`...`
 * 改为：
 *   import { ModalOverlay, ModalContainer } from './BaseModal';
 *   const Modal = styled(ModalContainer)`max-width: 800px;`;
 *
 * 用法二（新弹窗）：<BaseModal show maxWidth="700px"> ...header/content/footer... </BaseModal>
 */

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${zLayers.modalOverlay};
  padding: 20px;

  ${media.phone} {
    padding: 0;
  }
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: ${props => props.$maxWidth || '600px'};
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

  ${media.phone} {
    width: 100%;
    max-width: 100%;
    height: 100dvh;
    max-height: 100dvh;
    border-radius: 0;
  }
`;

const BaseModal = ({ show = true, maxWidth, className, children }) => {
  if (!show) return null;
  // 注意：遮罩上不绑定 onClick 关闭，背景点击不会关闭弹窗（项目规则）。
  return (
    <ModalOverlay>
      <ModalContainer $maxWidth={maxWidth} className={className}>
        {children}
      </ModalContainer>
    </ModalOverlay>
  );
};

export default BaseModal;
